import React, { createContext, useContext, useState, useCallback } from 'react';

const VisitsContext = createContext();

export function VisitsProvider({ children }) {
  const now = new Date();
  const [startDate, setStartDate] = useState(new Date(now.getFullYear(), now.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(now.getFullYear(), now.getMonth() + 1, 0));

  const [presetType, setPresetType] = useState(null);
  const [presetValue, setPresetValue] = useState(null);

  const getFormattedDates = useCallback(() => {
    return {
      formattedStartDate: startDate.toISOString().split('T')[0],
      formattedEndDate: endDate.toISOString().split('T')[0]
    };
  }, [startDate, endDate]);

  const value = {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    getFormattedDates,
    presetType,
    setPresetType,
    presetValue,
    setPresetValue
  };

  return (
    <VisitsContext.Provider value={value}>
      {children}
    </VisitsContext.Provider>
  );
}

export function useVisits() {
  const context = useContext(VisitsContext);

  if (!context)
    throw new Error('useVisits must be used within a VisitsProvider');

  return context;
}